/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TaskTriggersEnum } from './taskTriggersEnum';


export interface CommonInfo { 
    description?: string;
    result?: object;
    triggered_by?: TaskTriggersEnum;
}
export namespace CommonInfo {
}


